import styled from "styled-components";

import { FlexJustCenter, Text, PageTitle } from "../../StyledComponents";

export const Tablewhole = styled.div`
  background: #ffffff;
  border-radius: 8px;
  height: 100%; /* adjust if needed */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
`;

export const PastTopTitle = styled(FlexJustCenter)`
  padding: 6px 28px 6px 20px;
  margin-bottom: 0px;
  display: ${(p) => p.display && p.display};
  justify-content: ${(p) => p.justifyCont && p.justifyCont};
`;

export const TableHead = styled.thead`
  text-align: left;
  background-color: ${(props) => props.background};
  color: ${(props) => props.color && props.color};
  table-layout: ${(p) => p.tableLayout && p.tableLayout};
  height: ${(p) => p.height && p.height};
  display: ${(p) => p.display && p.display};
  width: ${(p) => p.width && p.width};
  justify-content: ${(p) => p.justifyCont && p.justifyCont};
  padding-right: ${(p) => p.paddingRight && p.paddingRight};
`;

export const TableBody = styled.tbody`
  text-align: left;
  table-layout: ${(p) => p.tableLayout && p.tableLayout};
  overflow-x: ${(p) => p.overflowX && p.overflowX};
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${(props) => props.background};
  height: ${(p) => p.height && p.height};
  width: ${(p) => p.width && p.width};
  padding-right: ${(p) => p.paddingRight && p.paddingRight};
  min-height: 0;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
  }
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
`;

export const TableHeadCell = styled.th`
  font-weight: 600;
  font-size: 14px;
  line-height: 12px;
  color: #3b82f6;
  padding: ${(p) => (p.padding ? p.padding : "20px")};
  width: ${(p) => p.width && p.width};
  text-align: ${(p) => p.textAlign && p.textAlign};
  padding-left: ${(p) => p.paddingLeft && p.paddingLeft};
`;

export const TableBodyCell = styled.td`
  font-size: 12px;
  line-height: 12px !important;
  color: #000000;
  //padding: 16px 40px 16px 38px;
  padding: ${(p) => (p.padding ? p.padding : "16px 40px 16px 38px")};
  border-bottom: ${(p) => (p.bodered ? "1px solid #D8E0F0" : "none")};
  border-bottom: ${(p) => (p.bodered ? "1px solid #D8E0F0" : "none")};
  width: ${(p) => p.width && p.width};
  align-items: ${(p) => p.alignItems && p.alignItems};
  display: ${(p) => p.display && p.display};
  justify-content: ${(p) => p.justifyContent && p.justifyContent};
  word-break: ${(p) => p.wordBreak && p.wordBreak};
`;

export const TableRow = styled.tr`
  text-align: left;
  background-color: ${(props) => props.background};
  &:last-child ${TableBodyCell} {
    border-bottom: none;
  }
  display: ${(p) => p.display && p.display};
  width: ${(p) => (p.width ? p.width : "100%")};
  height: ${(p) => p.height && p.height};
  justify-content: ${(p) => p.justifyCont && p.justifyCont};
  align-items: ${(p) => p.alignItem && p.alignItem};
  table-layout: ${(p) => p.tableLayout && p.tableLayout};
  grid-template-columns: ${(p) => p.tempColumns && p.tempColumns};
  margin: ${(p) => p.margin && p.margin};
  padding: ${(p) => p.padding && p.padding};
  &.hover_row:hover {
    overflow-x: hidden;
    background-color: #fafafa;
    /* padding-right: 0px; */
  }

  &.hover_row:hover ${TableBodyCell} {
    padding-right: 0px !important;
  }
`;

export const ResText = styled(Text)`
  @media (max-width: 1024px) {
    font-size: 12px !important;
    line-height: 14px !important;
  }
  word-break: ${(p) => p.wordBreak && p.wordBreak};
`;

export const RespTitle = styled(PageTitle)`
  @media (max-width: 1024px) {
    font-size: 18px !important;
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;

  background-color: ${(p) => p.bg};
  color: ${(p) => p.color};
`;
